export function shuffle<T>(array: T[]): T[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

/** One choice in a per-viewer shuffled multiple-choice question. `originalIndex`
 *  is the choice's authored (DB) position, used to route a click back to the
 *  answer that gets persisted and graded. */
export type ShuffledAnswer = { text: string; originalIndex: number }

/**
 * Returns the per-viewer shuffled answer choices for a multiple-choice question,
 * computing once and caching by questionId. Recomputes only if the answer count
 * changes; otherwise reuses the same array reference so the order stays stable
 * across re-renders and navigation. See BL-4382.
 */
export function buildShuffledAnswers(
  cache: Map<string, ShuffledAnswer[]>,
  questionId: string,
  answers: readonly string[]
): ShuffledAnswer[] {
  let result = cache.get(questionId)
  if (!result || result.length !== answers.length) {
    const order = shuffle(Array.from({ length: answers.length }, (_, i) => i))
    result = order.map((originalIndex) => ({
      text: answers[originalIndex],
      originalIndex,
    }))
    cache.set(questionId, result)
  }
  return result
}
